// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"top__wrap--3Lfa8"};